// extracted by mini-css-extract-plugin
export default {"container":"system-statistics_container__jQ7Fg","content-container":"system-statistics_content-container__lY3PU","inner-tab-container":"system-statistics_inner-tab-container__zjYQ0"};